/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SyncScheduleDisplaysModal_ScheduleFragment = { __typename: 'Schedule', id: string, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }> };

export type SyncScheduleToDisplaysMutationVariables = Types.Exact<{
  input: Types.ScheduleSyncDisplaysInput;
}>;


export type SyncScheduleToDisplaysMutation = { __typename: 'Mutation', scheduleSyncDisplays: { __typename: 'ScheduleSyncDisplaysPayload', displays: Array<{ __typename: 'Display', id: string }> } };

export const SyncScheduleDisplaysModal_ScheduleFragmentDoc = gql`
    fragment SyncScheduleDisplaysModal_schedule on Schedule {
  id
  outOfSyncDisplays: displays(filter: {state: OUT_OF_SYNC}) {
    id
  }
}
    `;
export const SyncScheduleToDisplaysDocument = gql`
    mutation SyncScheduleToDisplays($input: ScheduleSyncDisplaysInput!) {
  scheduleSyncDisplays(input: $input) {
    displays {
      id
    }
  }
}
    `;
export type SyncScheduleToDisplaysMutationFn = ApolloReactCommon.MutationFunction<SyncScheduleToDisplaysMutation, SyncScheduleToDisplaysMutationVariables>;

/**
 * __useSyncScheduleToDisplaysMutation__
 *
 * To run a mutation, you first call `useSyncScheduleToDisplaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncScheduleToDisplaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncScheduleToDisplaysMutation, { data, loading, error }] = useSyncScheduleToDisplaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncScheduleToDisplaysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncScheduleToDisplaysMutation, SyncScheduleToDisplaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncScheduleToDisplaysMutation, SyncScheduleToDisplaysMutationVariables>(SyncScheduleToDisplaysDocument, options);
      }
export type SyncScheduleToDisplaysMutationHookResult = ReturnType<typeof useSyncScheduleToDisplaysMutation>;
export type SyncScheduleToDisplaysMutationResult = ApolloReactCommon.MutationResult<SyncScheduleToDisplaysMutation>;
export type SyncScheduleToDisplaysMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncScheduleToDisplaysMutation, SyncScheduleToDisplaysMutationVariables>;